import { render } from "./SospensioniPage.vue?vue&type=template&id=4df9ae60&scoped=true"
import script from "./SospensioniPage.vue?vue&type=script&lang=js"
export * from "./SospensioniPage.vue?vue&type=script&lang=js"

import "./SospensioniPage.vue?vue&type=style&index=0&id=4df9ae60&scoped=true&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4df9ae60"]])

export default __exports__